/***************************************************************************************************
** isEnabledFn
***************************************************************************************************/

import isValueUndefined from "@utils/helpers/object/isValueUndefined";
import isTrue from "@utils/helpers/boolean/isTrue";

export default function isEnabledFn({ isEnabledValue, isDisabledValue, fallbackValue = false }) {
  // Default to fallback if both values are undefined
  if (isValueUndefined(isEnabledValue) && isValueUndefined(isDisabledValue)) {
    return fallbackValue;
  }

  // If isDisabled is defined, it takes precedence, regardless of isEnabled's value
  if (!isValueUndefined(isDisabledValue)) {
    return !isTrue(isDisabledValue);
  }

  // If only isEnabled is defined, use its value
  return isTrue(isEnabledValue);
}
